import moment from "moment"
import VueI18n from "vue-i18n"
import { AlarmLevel, LEVEL_ICONS, LEVEL_VARIANTS } from "@/types/alarm"

export function levelVariant(level: AlarmLevel): string {
    return LEVEL_VARIANTS[level] ?? "secondary"
}

export function levelIconClass(level: AlarmLevel): string {
    return LEVEL_ICONS[level] ?? "fa-solid fa-bell"
}

export function sourceIcon(source: string): string {
    if (source === "predictor") return "fa-solid fa-brain fa-fw"

    if (source === "controller") return "fa-solid fa-microchip fa-fw"

    if (source === "cloud") return "fa-solid fa-cloud fa-fw"

    return "fa-crosshairs"
}

export function formatDate(date: string | null, humanize = true): string {
    if (!humanize) return date ? moment(date).format("DD. MM. YYYY HH:mm") : "–"

    const diff = moment(date).diff(moment())

    return moment.duration(diff).humanize(true)
}

export function alarmTypeTitle(i18n: VueI18n, type: string): string {
    const key = `alarms.types.${type}.title`

    return i18n.te(key) ? (i18n.t(key) as string) : type
}

export function alarmSource(i18n: VueI18n, source: string): string {
    const key = `alarms.source.${source}`

    return i18n.te(key) ? (i18n.t(key) as string) : source
}

export function alarmTypeDescription(i18n: VueI18n, type: string): string {
    const key = `alarms.types.${type}.description`

    return i18n.te(key) ? (i18n.t(key) as string) : type
}

export function alarmTypeFix(i18n: VueI18n, type: string): string | null {
    const key = `alarms.types.${type}.fix`

    if (!i18n.te(key)) return null

    const fix = i18n.t(key) as string

    return fix ? fix : null
}

export function alarmLevelLabel(i18n: VueI18n, level: AlarmLevel): string {
    const key = `alarms.level.${level}`

    return i18n.te(key) ? (i18n.t(key) as string) : level
}
